import React from 'react';
import styles from './Modal.module.scss';

const Modal = ({ isOpen, onClose, children, wide = false }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={`${styles.modalContent} ${wide ? styles.modalWide : ''}`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <button className={styles.closeButton} onClick={onClose} aria-label="Fermer">
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;

